exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1; }\n\n.content {\n  position: relative;\n  height: 600px;\n  margin: 70px auto;\n  max-width: 700px;\n  background-color: #fff; }\n\n.button__close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  font-size: 30px;\n  padding: 10px 15px;\n  background-color: grey;\n  color: #FFF; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/components/popup/popup.component.scss
// module id = ../../../../../src/app/components/popup/popup.component.scss
// module chunks = main